<template>
    <div style="padding: 15px;height: 100vh">
        <div class="app-content">
            <a-card>
                <template #title>
                <div style="display: flex; align-items: center;">
                    <span>
                        {{ idUser ? 'ข้อมูลผู้ใช้งาน (Admin)' : 'เพิ่มผู้ใช้งาน (Admin)' }}
                    </span>
                    <a-button
                        v-if="idUser && !editMode"
                        type="primary"
                        size="small"
                        style="margin-left: 12px; vertical-align: middle;"
                        @click="editMode = true"
                    >
                        <template #icon>
                            <span class="material-symbols-outlined" style="font-size: 18px;">edit</span>
                        </template>
                        แก้ไขข้อมูล
                    </a-button>
                </div>
            </template>
                <template #extra>
                    <a-button style="display: flex" @click="rollbackPage()" size="large">
                        <template #icon>
                            <span class="material-symbols-outlined">arrow_back_ios</span>
                        </template>
                        ย้อนกลับ
                    </a-button>
                </template>
                <div style="display: flex; text-align: left;">
                    <div class="field_align" style="width: 100%; padding-left: 0;">
                        <a-form 
                            :model="formState"
                                name="register-form"
                                layout="horizontal"
                                :label-col="{ span: 4 }"
                                :wrapper-col="{ span: 20 }"
                                 labelAlign="left"
                                style="width: 100%;"
                            autocomplete="off"  @finish="handleFormSubmit" @finishFailed="onFinishFailed">
                            <a-divider orientation="left">Company Type</a-divider>
                           <a-form-item 
                                label="ประเภทธุรกิจ" 
                                name="business_type_id" 
                                :rules="!idUser ? [{ required: true, message: 'โปรดเลือกประเภทธุรกิจ' }] : []">
                                <a-radio-group v-if="!idUser" v-model:value="formState.business_type_id">
                                    <a-radio value="2">Logistics</a-radio>
                                    <a-radio value="3">Logistics-A</a-radio>
                                    <a-radio value="1">Car Rental</a-radio>
                                    <a-radio value="4">Car Rental-A</a-radio>
                                </a-radio-group>
                                <span v-else> {{businessTypeChooseName}} </span>
                            </a-form-item>
                            <a-form-item 
                                label="ประเภทบริษัท"
                                name="tax_id"
                                :rules="!idUser ? [{ required: true, message: 'โปรดเลือกประเภทบริษัท' }] : []">
                                <a-radio-group v-if="!idUser" v-model:value="formState.tax_id">
                                    <a-radio value="1">Tour</a-radio>
                                    <a-radio value="2">Garage</a-radio>
                                    <a-radio value="3">Non-Commercial</a-radio>
                                    <a-radio value="4">Commercial</a-radio>
                                </a-radio-group>
                                <span v-else> {{companyTypeChooseName}}</span>
                            </a-form-item>

                            <a-form-item label="ชื่อบริษัท/ลูกค้า" name="company_name"
                                :rules="[{ required: true, message: 'โปรดกรอกข้อมูลของคุณ' }]">
                                <a-input v-model:value="formState.company_name" :disabled="isDisabledEdit" />
                            </a-form-item>

                            <a-form-item label="เลขที่ผู้เสียภาษี" name="company_tax_id"
                                :rules="[{ required: true, message: 'โปรดกรอกข้อมูลของคุณ' },
                                         { validator: validateTaxID, trigger: 'change' }
                                ]">
                                <a-input v-model:value="formState.company_tax_id" :disabled="isDisabledEdit"/>
                            </a-form-item>

                            <a-form-item 
                            label="โลโก้บริษัท"
                            name="company_logo"
                            :rules="[{ required: true, message: 'โปรดอัพโหลดโลโก้บริษัทของคุณ' }]">
                                <a-form-item name="company_logo" no-style>
                                    <a-upload v-model:file-list="fileList" list-type="picture-card"
                                            :disabled="isDisabledEdit"
                                            class="avatar-uploader"
                                            action="https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6"
                                            @change="upload_files($event, 'company_logo')" method="GET"
                                            :before-upload="setFileType"
                                            accept="image/*"
                                            @remove="remove_uploaded_file($event)">
                                            <img v-if="formState['company_logo']" :src="formState['company_logo']"
                                                :style="`width: 100px;object-fit: cover`"
                                                alt="avatar" />
                                            <div v-else>
                                                <p class="ant-upload-drag-icon">
                                                    <span class="material-symbols-outlined"
                                                        style="font-size: 5rem">upload_file</span>
                                                </p>
                                                คลิกเพื่ออัพโหลดรูปภาพ
                                            </div>
                                    </a-upload>
                                </a-form-item>
                            </a-form-item>

                            <a-form-item label="ที่อยู่บริษัท" name="company_address"
                                :rules="[{ required: true, message: 'โปรดกรอกข้อมูลของคุณ' }]">
                                <a-textarea v-model:value="formState.company_address" :disabled="isDisabledEdit"/>
                            </a-form-item>

                            <a-form-item label="ที่อยู่เรียกเก็บเงินของบริษัท" name="company_billing_address"
                                :rules="[{ required: true, message: 'โปรดกรอกข้อมูลของคุณ' }]">
                                <a-textarea v-model:value="formState.company_billing_address" :disabled="isDisabledEdit"/>
                            </a-form-item>

                            <a-form-item label="เบอร์โทรศัพท์ของบริษัท" name="company_phone_no"
                                :rules="[{ required: true, message: 'โปรดกรอกข้อมูลของคุณ' },
                                         { validator: validate_Phone, trigger: 'change' }
                                ]">
                                <a-input v-model:value="formState.company_phone_no" :disabled="isDisabledEdit"/>
                            </a-form-item>
                            <a-form-item label="อีเมลของบริษัท" name="company_email"
                                :rules="[{ required: true, message: 'โปรดกรอกข้อมูลของคุณ' },
                                         { validator: validateEmail, trigger: 'change' }
                                ]">
                                <a-input v-model:value="formState.company_email" :disabled="isDisabledEdit"/>
                            </a-form-item>
                            <a-form-item label="ขนาดของบริษัท" name="company_size"
                                    :rules="[{ required: true, message: 'โปรดกรอกข้อมูลของคุณ' }]">
                                <a-select v-model:value="formState.company_size" :disabled="isDisabledEdit">
                                    <a-select-option value="small">
                                    <div class="option-content">
                                        <span>ขนาดเล็ก</span>
                                        <span class="option-desc">มีรถบริหารน้อยกว่า 30 คัน</span>
                                    </div>
                                    </a-select-option>
                                    <a-select-option value="medium">
                                    <div class="option-content">
                                        <span>ขนาดกลาง</span>
                                        <span class="option-desc">มีรถบริหารมากกว่า 30 คัน แต่น้อยกว่า 100 คัน</span>
                                    </div>
                                    </a-select-option>
                                    <a-select-option value="large">
                                    <div class="option-content">
                                        <span>ขนาดใหญ่</span>
                                        <span class="option-desc">มีรถบริหารมากกว่า 100 คัน</span>
                                    </div>
                                    </a-select-option>
                                </a-select>
                                </a-form-item>
                            <a-form-item label="ชื่อธนาคาร" name="company_bank"
                                :rules="[{ required: true, message: 'โปรดกรอกข้อมูลของคุณ' }]">
                                <a-select v-model:value="formState.company_bank" :disabled="isDisabledEdit">
                                    <a-select-option v-for="option in formState.banks" :key="option.id" :value="option.id">
                                        {{ option.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item label="ชื่อสาขาของธนาคาร" name="company_bank_branch"
                                :rules="[{ required: true, message: 'โปรดกรอกข้อมูลของคุณ' }]">
                                <a-input v-model:value="formState.company_bank_branch" :disabled="isDisabledEdit"/>
                            </a-form-item>

                            <a-form-item label="ชื่อบัญชี" name="company_bank_acc_name"
                                :rules="[{ required: true, message: 'โปรดกรอกข้อมูลของคุณ' }]">
                                <a-input v-model:value="formState.company_bank_acc_name" :disabled="isDisabledEdit"/>
                            </a-form-item>

                            <a-form-item label="เลขที่บัญชี" name="company_bank_acc_no"
                                :rules="[{ required: true, message: 'โปรดกรอกข้อมูลของคุณ' },
                                         { validator: validateBankNo , trigger: 'change' }
                                ]">
                                <a-input v-model:value="formState.company_bank_acc_no" :disabled="isDisabledEdit"/>    
                            </a-form-item>

                            <a-divider orientation="left">Company owner account (ADMIN)</a-divider>
                            <a-form-item label="ชื่อผู้กรอกข้อมูล" name="name_fillings"
                                :rules="[{ required: true, message: 'โปรดกรอกข้อมูลของคุณ' }]">
                                <a-input v-model:value="formState.name_fillings" :disabled="isDisabledEdit"/>
                                
                            </a-form-item>
                            <a-form-item
                                name="admin_firstname"
                                :rules="[{ required: true, message: 'โปรดกรอกข้อมูลของคุณ' }]"
                                >
                                <template #label>
                                    <div>
                                    <div>ชื่อ</div>
                                    <div style="color: #999; font-size: 12px; margin-bottom: -12px;">ใช้สำหรับติดต่อเปลี่ยนรหัสผ่าน</div>
                                    </div>
                                </template>
                                <a-input v-model:value="formState.admin_firstname" :disabled="isDisabledEdit"/>
                            </a-form-item>

                            <a-form-item
                                name="admin_lastname"
                                :rules="[{ required: true, message: 'โปรดกรอกข้อมูลของคุณ' }]"
                                >
                                <template #label>
                                    <div>
                                    <div>นามสกุล</div>
                                   <div style="color: #999; font-size: 12px; margin-bottom: -12px;">ใช้สำหรับติดต่อเปลี่ยนรหัสผ่าน</div>
                                    </div>
                                </template>
                                <a-input v-model:value="formState.admin_lastname" :disabled="isDisabledEdit"/>
                            </a-form-item>

                            <a-form-item
                                name="admin_email"
                                :rules="[{ required: true, message: 'โปรดกรอกข้อมูลของคุณ' },
                                         { validator: validateEmail, trigger: 'change' }
                                ]"
                                >
                                <template #label>
                                    <div>
                                    <div>อีเมล</div>
                                   <div style="color: #999; font-size: 12px; margin-bottom: -12px;">ใช้สำหรับติดต่อเปลี่ยนรหัสผ่าน</div>
                                    </div>
                                </template>
                                <a-input v-model:value="formState.admin_email" :disabled="isDisabledEdit"/>
                            </a-form-item>

                            <a-form-item
                                name="admin_phone_no"
                                :rules="[{ required: true, message: 'โปรดกรอกเบอร์โทรศัพท์' },
                                        { validator: validate_Phone, trigger: 'change' }
                                ]"
                                >
                                <template #label>
                                    <div>
                                    <div>เบอร์โทรศัพท์</div>
                                   <div style="color: #999; font-size: 12px; margin-bottom: -12px;">ใช้สำหรับติดต่อเปลี่ยนรหัสผ่าน</div>
                                    </div>
                                </template>
                                <a-input v-model:value="formState.admin_phone_no" :disabled="isDisabledEdit"/>
                            </a-form-item>
                            <a-tooltip placement="top">
                                <template #title>
                                    <span>ใช้สำหรับเข้าสู่ระบบ</span>
                                </template>
                                <a-form-item label="ชื่อบัญชีผู้ใช้" name="admin_username"
                                :rules="[
                                          {
                                            required: true,
                                            message: 'โปรดกรอกข้อมูลของคุณ',
                                          },
                                          {
                                            validator: validate_duplicate,
                                            trigger: 'change',
                                          },
                                        ]"

                                 >
                                  <a-input v-model:value="formState.admin_username" :disabled="isDisabledEdit" />
                                </a-form-item>
                                </a-tooltip>

                                    <a-form-item v-if="!idUser" style="margin-top: 20px; display: flex; gap: 15px;">
                                        <a-button type="primary" html-type="submit">สมัครสมาชิก</a-button>
                                    </a-form-item>
                                    <div v-if="idUser && editMode" style="margin-top: 20px; display: flex; gap: 15px;">
                                    <a-button type="primary" html-type="submit" :loading="saving" style="min-width: 120px;">
                                        <template #icon>
                                            <span class="material-symbols-outlined" style="font-size: 20px;">save</span>
                                        </template>
                                        บันทึกข้อมูล
                                    </a-button>
                                    <a-button @click="cancelEdit" :disabled="saving" style="min-width: 120px;">
                                        ยกเลิก
                                    </a-button>
                            </div>
                        </a-form>
                        
                    </div>
                </div>
            </a-card>
        </div>
    </div>
</template>

<script>
import input_primary from '../components/input_primary.vue'
import UserService from '../api/UserService.js'
import BankService from '../api/BankService.js'
import { defineComponent, reactive, toRaw } from 'vue';
import { UploadOutlined, InboxOutlined } from '@ant-design/icons-vue';
import SystemService from '../api/SystemService';
import BusinessTypeService from '../api/BusinessTypeService';
import CompanyService from '../api/CompanyService';
import CompanyTypeService from '../api/CompanyTypeService';
import CarCompanyService from '../api/CarCompanyService';
import Swal from 'sweetalert2'

export default defineComponent({
    components: {
        input_primary,
        UploadOutlined,
        InboxOutlined
    },
    name: 'Login',
    data() {
        return {
            cover_img: require('@/assets/images/fleetex-home-page.png'),
            logo_img: require('@/assets/images/fleetex-log-in-logo.png'),
            idUser: null,
            businessType : [],
            companyTypeData : [],
            companyData : [],
            businessTypeChooseName : null,
            companyTypeChooseName : null,
            companyCarData : [],
            editMode: false,
            saving: false,
            backupForm: null,
        }
    },
    computed: {
        render_type() {
            return this.$route.params?.type;
        },
        isDisabled() {
            return (this.idUser !== null && this.idUser !== undefined);
        },
        isDisabledEdit() {

            return this.idUser && !this.editMode;
        }
    },
    watch: {
        $route(newPath, oldPath) {
            this.idUser = this.render_type
            this.resetFormState();
        }
    },
    setup() {
        const fileList = []

        const formState = reactive({
            company_name: null,
            company_type: null,
            company_tax_id: null,
            company_logo: null,
            company_address: null,
            company_billing_address: null,
            company_phone_no: null,
            company_email: null,
            company_size: null,
            company_bank: null,
            company_bank_branch: null,
            company_bank_acc_name: null,
            company_bank_acc_no: null,
            banks: [],
            business_type_id: null,
            //Admin
            name_fillings: null,
            admin_firstname: null,
            admin_lastname: null,
            admin_email: null,
            admin_phone_no: null,
            admin_username: null,
            admin_password: null,
            admin_confirm_password: null
        });
        const onFinishFailed = errorInfo => {
            console.log('Failed:', errorInfo);
            console.log('Fields with error:', errorInfo.errorFields);
            console.log('Form values:', errorInfo.values);
        };

        const get_company_bank = async () => {
            try {
                const res = await BankService.getAll();
                formState.banks = res.data;
            } catch (error) {
                console.error("Error fetching banks:", error);
            }
        };

        return {
            formState,
            onFinishFailed,
            fileList,
            get_company_bank
        };
    },
    methods: {
        handleFormSubmit(values) {
            if (this.idUser && this.editMode) {
                this.saveEdit();
            } else {
                this.onFinish(values);
            }
        },
        async rollbackPage(){
            this.$router.push(`/app/admin`)
        },
        async get_company_bank() {
            for (var key in this.formState.company_bank.inputs) {
                const { input_type, modelname} = this.formState.company_bank.inputs[key]
                if ((input_type == 'select') && modelname) {
                    if (modelname == 'Bank') {
                        const res = await BankService.getAll()
                        this.formState.company_bank[modelname] = res.data
                    } 
                }
            }
        },
        resetFormState() {
            this.formState = {
                company_name: null,
                company_type: null,
                company_tax_id: null,
                company_logo: null,
                company_address: null,
                company_billing_address: null,
                company_phone_no: null,
                company_email: null,
                company_size: null,
                company_bank: null,
                company_bank_branch: null,
                company_bank_acc_name: null,
                company_bank_acc_no: null,
                banks: [],
                business_type_id: null,
                name_fillings: null,
                admin_firstname: null,
                admin_lastname: null,
                admin_email: null,
                admin_phone_no: null,
                admin_username: null,
                admin_password: null,
                admin_confirm_password: null
            };
        },
        async remove_uploaded_file({ uid }) {
            this.formState[uid] = ''
        },
        setFileType(file) {
            const fileType = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/gif' 
            || file.type === 'image/raw' || file.type === 'image/webp' || file.type === 'image/tif' || file.type === 'image/psd' || file.type === 'image/svg';
            if (!fileType) {
                this.$message.error('คุณสามารถอัปโหลดได้เฉพาะไฟล์รูปภาพเท่านั้น!');
            }
            return fileType
        },
        upload_files(event, field) {
            const vue = this
            const file = event.file.originFileObj
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => {
                vue.formState[field] = reader.result
            }

            return `https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6`
        },
        onFinish(values) {
           console.log('ค่า values ที่ได้จากฟอร์ม:', values)
            this.$emit('register_value', values)
        },
        async sign_in() {
            const data = await UserService.login({ username: this.username, password: this.password })
            if (data.token) {
                localStorage.setItem('token', data.token)

                location.reload()
            }
        },
        async validate_duplicate(_rule, value) {
            return new Promise((resolve, reject) => {
                if (!value || value === this.companyData.adminUsername) {
                    return resolve();
                }     
                setTimeout(() => {
                    SystemService.check_duplicate(
                        "Admin",
                        `field=username&value=${value}&id=create`
                    )
                    .then((res) => {
                        if (res) {
                            reject("มีข้อมูลนี้อยู่แล้ว");
                        } else {
                            resolve();
                        }
                    })
                    .catch(err => {
                        console.warn("ไม่สามารถตรวจสอบ Username ได้ (Network Error), แต่จะปล่อยผ่านไปก่อน", err);
                        resolve(); 
                    });
                }, 300);
            });
        },

        async validate_Phone(_rule, value) {
        
        if (!value || value.trim() === '') {
            return Promise.resolve();
        }

        const invalidCharsRegex = /[^0-9-]/;
        if (invalidCharsRegex.test(value)) {
            return Promise.reject('กรุณากรอกเฉพาะตัวเลขและเครื่องหมาย - เท่านั้น');
        }

        const digitsOnly = value.replace(/-/g, '');

        const isBangkokNumber = digitsOnly.startsWith('02') && digitsOnly.length === 9;
        const isMobileNumber = digitsOnly.startsWith('0') && digitsOnly.length === 10;

        if (isBangkokNumber || isMobileNumber) {
            return Promise.resolve(); 
        } else {
            return Promise.reject('รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง (ต้องเป็น 0XX XXX XXXX หรือ 02 XXX XXXX และ มี - หรือไม่มีก็ได้)');
        }
        },

        async validateBankNo (_rule, value) {
        if (!value) {
            return Promise.resolve();
        }
        if (/^[0-9-]+$/.test(value)) {
            return Promise.resolve();
        } else {
            return Promise.reject('กรุณากรอกเฉพาะตัวเลขและเครื่องหมายขีด (-) เท่านั้น');
        }
        },

        async validateEmail(_rule, value){
           const emailPattern = /^(?!\.)(?!.*\.\.)(?!.*\.$)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]{1,}(?<!\.)@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
            if (!value) {
                return Promise.resolve();
            }
            const [local, domain] = value.split('@');
            if (!local || !domain) {
                
                return Promise.reject('รูปแบบอีเมลไม่ถูกต้อง');
            }
            if (local.length > 64) {
                return Promise.reject('ส่วนของอีเมลก่อน @ ต้องมีความยาวไม่เกิน 64 ตัวอักษร');
            }
            if (domain.length > 255) {
                return Promise.reject('ส่วนของโดเมนหลัง @ ต้องมีความยาวไม่เกิน 255 ตัวอักษร');
            }
            if (emailPattern.test(value)) {
                return Promise.resolve();
            } else {
                return Promise.reject('รูปแบบอีเมลไม่ถูกต้อง');
            }
        },

        async validateTaxID (_rule, value)  {
            if (!value) {
                return Promise.resolve();
            }
            if (!/^[0-9]+$/.test(value)) {
                return Promise.reject('กรุณากรอกเฉพาะตัวเลขเท่านั้น');
            }
            if (value.length !== 13) {
                return Promise.reject('ต้องมีความยาว 13 หลักเท่านั้น');
            }
            return Promise.resolve();
        },

        async saveEdit() {
            const confirmResult = await Swal.fire({
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                title: 'บันทึกข้อมูล',
                showCancelButton: true,
                confirmButtonText: 'ยืนยัน',
                cancelButtonText: 'ยกเลิก',
                reverseButtons: false,
                customClass: {
                    confirmButton: 'swal2-confirm-custom',
                    cancelButton: 'swal2-cancel-custom'
                }
            });

            if (!confirmResult.isConfirmed) {
                return;
            }

            this.saving = true;

            Swal.fire({
                willOpen: () => {
                    Swal.showLoading();
                },
                title: 'กรุณารอสักครู่',
                allowOutsideClick: false,
                showConfirmButton: false,
                customClass: {
                    popup: 'swal-loading-popup',
                    title: 'swal-loading-title'
                }   
            });

            try {
                const payload = { ...this.formState };
                payload.business_type_id = this.backupForm.business_type_id;
                payload.tax_id = this.backupForm.tax_id;
                await CompanyService.updateCompanyData(this.idUser, payload);
                sessionStorage.setItem('flashMessage', 'saveSuccess');
                this.$router.push(`/app/admin`);

            } catch (e) {
                Swal.close(); 
                let errorTitle = 'เกิดข้อผิดพลาด บันทึกไม่สำเร็จ';
                if (!navigator.onLine) {
                    errorTitle = 'เกิดข้อผิดพลาด บันทึกไม่สำเร็จ';
                } 
                const result = await Swal.fire({ 
                    iconHtml: '<div class="swal-custom-icon-warning">!</div>',
                    title: errorTitle,
                    showCancelButton: true,
                    confirmButtonText: 'ลองอีกครั้ง',
                    cancelButtonText: 'ยกเลิก',
                    reverseButtons: false, 
                    confirmButtonColor: '#1890ff', 
                    customClass: {
                        popup: 'swal-custom-popup',
                        confirmButton: 'swal2-confirm-custom', 
                        cancelButton: 'swal2-cancel-custom'  
                    }
                });
                if (result.isConfirmed) {
                    this.saveEdit();
                } else {
                    this.saving = false;
                }
            }
        },

      cancelEdit() {

        if (this.backupForm) {
          Object.assign(this.formState, JSON.parse(JSON.stringify(this.backupForm)));
        }
        this.editMode = false;
        window.location.reload();
      }
    },
    async mounted() {
        this.get_company_bank()
        this.idUser = this.render_type
        let checkInt = parseInt(this.idUser)||null
        if(!checkInt){
            this.idUser = null
        }
        let res = await BusinessTypeService.getAll()
        if(res){
            this.businessType = res.data
        }
        let result = await CompanyTypeService.getAll()
        if(result){
            this.companyTypeData = result.data
        }
        if(this.idUser){
            let res3 = await CarCompanyService.getByCompanyId(this.idUser);
            let admin = await SystemService.get_core('getEmailAdminByCompanyId',`company_id=${this.idUser}`);
            let res2 = await CompanyService.getCompaniesData(this.idUser);
            if (res2) {
                this.companyData = res2.data[0];
                this.companyCarData = res3[0];

                const businessTypeId = this.companyData.companyBusinessType;
                const companyTypeId = this.companyData.companyType;

                this.formState.business_type_id = businessTypeId || null;
                this.formState.tax_id = companyTypeId || null;

                this.businessTypeChooseName = businessTypeId 
                    ? (this.businessType.find(b => b.id == businessTypeId)?.name || 'N/A') 
                    : 'N/A';

                this.companyTypeChooseName = companyTypeId 
                    ? (this.companyTypeData.find(c => c.id == companyTypeId)?.name || 'N/A') 
                    : 'N/A';

                this.formState.company_name = this.companyCarData.fullname || null;
                this.formState.company_tax_id = this.companyCarData.tax_id || null;
                this.formState.company_logo = this.companyCarData.logo || null;
                this.formState.company_address = this.companyCarData.address || null;
                this.formState.company_billing_address = this.companyCarData.billing_address || null;
                this.formState.company_phone_no = this.companyCarData.phone_no || null;
                this.formState.company_email = this.companyCarData.email || null;
                this.formState.company_size = this.companyData.company_size || null;
                this.formState.company_bank = this.companyCarData.bank_id || null;
                this.formState.company_bank_branch = this.companyCarData.bank_branch || null;
                this.formState.company_bank_acc_name = this.companyCarData.bank_account_name || null;
                this.formState.company_bank_acc_no = this.companyCarData.bank_account_no || null;

                this.formState.name_fillings = this.companyData.name_fillings || null;
                this.formState.admin_firstname = this.companyData.adminFirstName || null;
                this.formState.admin_lastname = this.companyData.adminLastName || null;
                this.formState.admin_email = admin ? admin : this.companyCarData.email || null;
                this.formState.admin_username = this.companyData.adminUsername || null;
                this.formState.admin_phone_no = this.companyData.adminPhoneNo || null;

                this.backupForm = JSON.parse(JSON.stringify(this.formState));

            }
        }
    }
})
</script>
<style lang="scss">
label,
h2 {
    font-weight: 400 !important;
}

.login-container {
    height: 100vh;
    display: flex;
    flex-wrap: wrap;
}

.login-form {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    @media (min-width: 992px) {
        max-width: 50%;
        flex: 0 0 50%;
    }
}

.form-card-img {
    width: 100%;
    min-height: 300px;
    background-size: cover;
    background-position: 50% 50%;

    @media (min-width: 992px) {
        max-width: 50%;
        flex: 0 0 50%;
    }
}
</style>
<style lang="scss" scoped>
.option-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.option-desc {
  color: #999;
  font-size: 0.85em;
  margin-left: 10px;
}

.swal-toast-popup {
  padding: 10px 20px !important;
  font-size: 16px;
  min-width: 260px;
  background-color: #28a745 !important; 
  color: white;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);

  .swal2-icon {
    margin: 0 10px 0 0;
  }
  .swal2-title {
    font-size: 16px;
    font-weight: 500;
    margin: 0;
  }
}
.field-desc {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
}

.swal2-popup {
  width: 250px !important;  // ปรับความกว้าง
  padding: 2em !important;  // ปรับ padding
  font-size: 1rem !important; // ปรับขนาดตัวอักษร
}
.swal2-icon.swal2-warning {
  border-width: 7px !important;
  
  .swal2-icon-content {
    font-weight: 600 !important;
    font-size: 50px !important;
  }
}

.swal2-icon-warning-bold {
  border-width: 5px !important;
  
  .swal2-icon-content {
    font-weight: 900 !important;
    font-size: 4em !important;
  }
}

// ปุ่มยกเลิก - พื้นขาว ตัวอักษรดำ
.swal2-cancel-custom {
  background-color: #ffffff !important;
  color: #000000 !important;
  border: 1px solid #d9d9d9 !important;
  
  &:hover {
    background-color: #f5f5f5 !important;
    color: #000000 !important;
  }
  
  &:focus {
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1) !important;
  }
}

// ปุ่มยืนยัน (ถ้าต้องการปรับแต่ง)
.swal2-confirm-custom {
  background-color: #1890ff !important;
  color: #ffffff !important;
  border: none !important;
  
  &:hover {
    background-color: #40a9ff !important;
  }
  
  &:focus {
    box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.2) !important;
  }

  .swal2-html-container {
  font-size: 1em !important;
  margin: 0.5em 0 !important;
  font-weight: 900 !important; 
  line-height: 1.5 !important;
  color: #000000 !important;  // text ก็เป็นสีดำด้วย

}.swal2-title {
  color: #000000 !important;
  font-weight: bold !important;  // bold
  font-size: 1em !important;
  padding: 0 0 0.5em !important;
}
}
.swal-toast-popup {
    width: auto !important;
    min-width: 0 !important;
    padding: 12px 22px !important;
    margin-top: 20px;
    font-size: 16px;
    background-color: #28a745 !important;
    color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

    .swal2-icon {
        margin: 0 10px 0 0;
    }

    // กฎนี้จะทำงานร่วมกับ customClass ใน JavaScript ของคุณ
    .swal2-title-custom-success {
        font-size: 16px !important;
        color: white !important;
        font-weight: 500;
        margin: 0;
    }
}
.swal-custom-popup .swal2-title {
  font-size: 15px !important; /* ปรับขนาดฟอนต์ของ Title */
  font-weight: bold !important;
  color: #000000 !important; /* สีดำ */
  top: -20px;
}

.swal-custom-icon-warning {
  width: 80px;
  height: 80px;
  border: 7px solid #f8bb86; /* สีส้ม */
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 60px;
  font-weight: bold;
  color: #f8bb86; /* สีส้ม */
  margin: 20px auto;

}
.swal-custom-popup .swal2-icon {
  border: 0 !important;
  width: auto !important;
  height: auto !important;
    top: -20px
}
.swal-custom-popup {
  width: 350px !important;
  height: 270px;
}
.swal-loading-popup {
  width: 350px !important;
  height: auto !important;
}
.swal-loading-title {
  font-size: 1.5rem !important; 
  font-weight: bold !important;
}
</style>
